import { Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { composeSignInUrl } from '@/modules/auth/services/oauth/composeSignInUrl';
import { Checkbox, Form, FormField } from '@/modules/forms';
import { Button } from '@/modules/ui';

import { button } from './DemoLoginForm.rules';
import { GdprLabel } from './GdprLabel';
import { useHandleDemoOAuthResult } from './hooks/useHandleOAuthResult';
import { demoLoginFormSchema, type DemoLoginFormSchemaType, type DemoLoginFormValues } from './schemas';

export const DemoLoginForm = () => {
    const { isLoading } = useHandleDemoOAuthResult();
    const { hash } = useLocation();

    return (
        <Form<DemoLoginFormSchemaType, DemoLoginFormValues>
            schema={demoLoginFormSchema}
            onSubmit={() => {
                window.location.assign(composeSignInUrl());
            }}
            defaultValues={{ gdpr: Boolean(hash) }}
        >
            <FormField<DemoLoginFormValues> name='gdpr'>
                <Controller<DemoLoginFormValues, 'gdpr'>
                    name='gdpr'
                    render={({ field: { ref, value, onChange, ...field } }) => (
                        <Checkbox
                            id='btn_demo_terms'
                            {...field}
                            checked={value}
                            onChange={e => {
                                onChange(e.target.checked);
                            }}
                            disabled={isLoading}
                        >
                            <GdprLabel />
                        </Checkbox>
                    )}
                />
            </FormField>

            <Button id='btn_demo_launch' type='primary' htmlType='submit' customStyle={button} loading={isLoading}>
                <FormattedMessage id='auth.login.button.demo' />
            </Button>
        </Form>
    );
};
